// SubscriptionService.js
import api from "../common/api";
import {
  subscriptions_current,
  subscriptions_history,
  subscriptions_usage_history,
  subscriptions_upgrade,
  subscriptions_create_razorpay_order,
  subscriptions_verify_razorpay_payment,
  subscription_plans,
  saas_invoices
} from "../common/endPoints";

const SubscriptionService = {
  async getCurrentSubscription() {
    return await api.get(subscriptions_current);
  },

  async getSubscriptionHistory() {
    return await api.get(subscriptions_history);
  },

  async getUsageHistory(params = {}) {
    return await api.get(subscriptions_usage_history, { params });
  },

  async getSubscriptionPlans() {
    return await api.get(subscription_plans);
  },

  async upgradeSubscription(params) {
    return await api.post(subscriptions_upgrade, params);
  },

  async createRazorpayOrder(params) {
    return await api.post(subscriptions_create_razorpay_order, params);
  },

  async verifyRazorpayPayment(params) {
    return await api.post(subscriptions_verify_razorpay_payment, params);
  },

  async getSaasInvoices() {
    return await api.get(saas_invoices);
  }
};

export default SubscriptionService;
